var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvImported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_cv_importato",
    "data-name": "icona cv importato",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_165",
    "data-name": "Tracciato 165",
    d: "M19.333,20.333A2.336,2.336,0,0,1,17,18V14.5a1.5,1.5,0,0,1,3,0v3.333a.5.5,0,0,1-1,0V14.5a.5.5,0,0,0-1,0V18a1.333,1.333,0,1,0,2.667,0V13.5a.5.5,0,0,1,1,0V18A2.336,2.336,0,0,1,19.333,20.333Z",
    transform: "translate(-5.667 -4.333)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_166",
    "data-name": "Tracciato 166",
    d: "M9.873,14.667H1.833A1.835,1.835,0,0,1,0,12.833v-11A1.835,1.835,0,0,1,1.833,0h8.333A1.835,1.835,0,0,1,12,1.833V7.487a.5.5,0,0,1-1,0V1.833A.834.834,0,0,0,10.167,1H1.833A.834.834,0,0,0,1,1.833v11a.834.834,0,0,0,.833.833h8.04a.5.5,0,0,1,0,1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_167",
    "data-name": "Tracciato 167",
    d: "M10.5,14.5h-7a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z",
    transform: "translate(-1 -4.5)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_168",
    "data-name": "Tracciato 168",
    d: "M10.5,10.5h-7a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z",
    transform: "translate(-1 -3.167)",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_169",
    "data-name": "Tracciato 169",
    d: "M7.167,6.5H3.5a.5.5,0,0,1,0-1H7.167a.5.5,0,0,1,0,1Z",
    transform: "translate(-1 -1.833)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvImported);
export default __webpack_public_path__ + "static/media/cv_imported.dcc8554b5633ea571f4f7da105fa4b74.svg";
export { ForwardRef as ReactComponent };